import _ from 'lodash';

import { deserialiseFundingRequirements } from './deserialiseFundingRequirements';
import { deserialiseWaitForOtherGuarantorsFundingRequirements } from './FundingSteps';
import { deserialiseSignedDocuments } from './signDocumentAction/SignDocumentsHelper';

export type TFundingRequirementsSteps = ReturnType<
    typeof orderFundingRequirements
>;

function orderByPriority(
    funding_requirement:
        | ReturnType<typeof deserialiseFundingRequirements>[0]
        | ReturnType<typeof deserialiseSignedDocuments>[0]
        | ReturnType<
              typeof deserialiseWaitForOtherGuarantorsFundingRequirements
          >[0]
) {
    const PRIORITY_ORDER = {
        BANK_DETAILS: 1,
        PENNY_TRANSFER: 2,
        ONFIDO_VERIFICATION: 3,
        ONFIDO_VIDEO_VERIFICATION: 3,
        IDVERSE_VERIFICATION: 3,
        MAJOR_SHAREHOLDER_CHECK: 4,
        DEBIT_CARD: 5,
        UPLOAD_GEWERBESCHEIN: 6,
        master_loan_agreement: 7,
        guarantee: 8,
        COMMISSION_CONSENT: 9,
        APPLICANT_CALL: 12
    } satisfies Partial<Record<(typeof funding_requirement)['type'], number>>;
    const LOWEST_PRIORITY = 100;

    return (
        PRIORITY_ORDER[
            funding_requirement.type as keyof typeof PRIORITY_ORDER
        ] || LOWEST_PRIORITY
    );
}

export const orderFundingRequirements = (
    fundingRequirements: ReturnType<typeof deserialiseFundingRequirements>,
    loanDocuments: ReturnType<typeof deserialiseSignedDocuments>,
    waitForOtherGuarantorsFundingRequirements?: ReturnType<
        typeof deserialiseWaitForOtherGuarantorsFundingRequirements
    > | null
) => {
    const allFundingRequirements = [
        ...fundingRequirements,
        ...loanDocuments,
        ...(waitForOtherGuarantorsFundingRequirements ?? [])
    ];

    return _.orderBy(allFundingRequirements, orderByPriority, 'asc');
};
